/**
 * Add multiple line items (Shop the look promo on collection grid).
 * Uses Cart AJAX API: POST /cart/add.js with JSON { items: [...] }.
 */
document.addEventListener('click', (evt) => {
  const btn = evt.target.closest('.js-collection-stl-bundle-add');
  if (!btn) return;

  evt.preventDefault();

  const raw = btn.getAttribute('data-stl-items');
  if (!raw) return;

  let items;
  try {
    items = JSON.parse(raw);
  } catch (e) {
    return;
  }
  if (!Array.isArray(items) || items.length === 0) return;

  if (btn.getAttribute('aria-disabled') === 'true') return;
  btn.setAttribute('aria-disabled', 'true');
  btn.classList.add('is-loading');

  fetch(theme.routes.cartAdd, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ items })
  })
    .then((response) => response.json().then((data) => ({ ok: response.ok, data, response })))
    .then(({ ok, data }) => {
      if (!ok) {
        const msg =
          typeof data.description === 'string'
            ? data.description
            : typeof data.message === 'string'
              ? data.message
              : 'Could not add to cart';
        throw new Error(msg);
      }

      document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));

      if (theme.settings.afterAddToCart === 'page') {
        setTimeout(() => {
          window.location.href = theme.routes.cart;
        }, 300);
        return;
      }

      if (theme.settings.afterAddToCart === 'drawer') {
        const drawer = document.querySelector('.js-cart-drawer');
        if (drawer) drawer.open(btn);
      } else if (theme.settings.afterAddToCart === 'notification') {
        const template = document.getElementById('AddedNotification')?.content?.firstElementChild;
        if (template) {
          const notification = template.cloneNode(true);
          notification.dataset.productTitle = items.length > 1 ? `${items.length} items` : '';
          const container = document.querySelector('.pageheader--sticky') || document.body;
          container.appendChild(notification);
        }
      }
    })
    .catch((err) => {
      document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
      window.alert(err.message || 'Could not add to cart');
    })
    .finally(() => {
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('is-loading');
    });
});
